import React, { Component } from "react";
import { connect } from "react-redux";
import { getAllSpecificatios } from "../actions/filesActions";
import Header from "../Search/Header";
import Main from "../Search/Main";

class Search extends Component {
  state = {
    fullName: "",
    email: "",
    content: ""
  };
  componentDidMount() {
    this.props.loadFilesData();
  }
  render() {
    return (
      <div>
        <Header />
        <Main />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    loadFilesData: () => dispatch(getAllSpecificatios())
  };
};

export default connect(
  null,
  mapDispatchToProps
)(Search);
